// extracted by mini-css-extract-plugin
export default {"welcomePromoBanner":"qBv8Mwu4IT33BrYCoWIePQ=="};